export default "__VITE_ASSET__ec61e21f__"